export default "__VITE_ASSET__Z94oX7fy__"